module.exports = __webpack_public_path__ + "static/img/fruits_berry2.73b23a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_berry2.png
// module id = QKzd
// module chunks = 1